import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import RecordOperation from '@/services/Record'
import { wizStandardInstance } from './instance'

export default class dataLabelManagementService {
  // 标签列表
  static async list(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdDataLabel?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增标签
  static async create(payload) {
    RecordOperation({ type: 'create' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdDataLabel', payload))
    return Callback(err, res)
  }
  // 编辑标签
  static async update(payload) {
    RecordOperation({ type: 'update' })
    const [err, res] = await To(wizStandardInstance.patch('/api/std/StdDataLabel', payload))
    return Callback(err, res)
  }
  // 删除标签
  static async remove(payload) {
    RecordOperation({ type: 'delete' })
    const [err, res] = await To(wizStandardInstance.delete('/api/std/StdDataLabel', payload))
    return Callback(err, res)
  }
  // 获取实体数据已绑定的标签
  static async entityLabels(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataLabel/entity_labels?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 修改实体数据已绑定的标签
  static async updateEntityLabels(payload) {
    RecordOperation({ type: 'query' })
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdDataLabel/save-data-label', payload)
    )
    return Callback(err, res)
  }

  static async detail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async upload(payload) {
    RecordOperation({ type: 'import' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdAttribute/import', payload))
    return Callback(err, res)
  }
  static async exportFile(payload) {
    RecordOperation({ type: 'export' })
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdAttribute/export', payload))
    return Callback(err, res)
  }
  static async downloadTemplate(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/StdAttribute/download', payload))
    return Callback(err, res)
  }
}
